import { Logger } from "@/types/utils";
import { useSnackbar } from "@dippi/ui";

const show = useSnackbar.getState().show;

export const log: Logger = {
    success: (message: string) => {
        show(message, "success");
    },
    info: (message: string) => {
        show(message, "info");
    },
    warn: (message: string) => {
        show(message, "warning");
    },
    error: (error: unknown) => {
        let message = "Unknown error";

        if (error instanceof Error) {
            if (error.name === "AbortError") message = "Request has been canceled our timed out";
            else message = error.message;
        }

        show(message, "error");
    },
};
